const input_en={
    "requiredErrorMessage":"Required field",
    "validationErrorMessage":"Invalid data"
}  
export default input_en;